module.exports = __webpack_public_path__ + "img/Vatika_logo.65dd55a7.png";